import type { ReactNode } from 'react';
import { SmallScreenGate, Toaster } from '@eureca/ui';
import { KeycloakGate } from '@/auth/KeycloakGate';
import { isPublicAlignmentPath } from '@/features/job-description/shared/public-path';

/**
 * DEV-258 — decide no boot se a aba é do APP Consultor ou do formulário da
 * pessoa gestora (`/descricao-vaga/*`). O formulário entra por token do link:
 * não pode disparar login nem `check-sso` no Keycloak dos consultores, e tem o
 * próprio aviso de tela pequena, que mantém o preenchido montado (D17).
 */
export function AppRoot({ pathname, children }: { pathname: string; children: ReactNode }) {
  if (isPublicAlignmentPath(pathname)) {
    return (
      <>
        {children}
        {/* DEV-261 AC-70 (23103): canto inferior direito, 64px da direita e 48px de baixo. */}
        <Toaster offset={{ right: 64, bottom: 48 }} />
      </>
    );
  }
  return (
    <SmallScreenGate>
      <KeycloakGate>
        {children}
        <Toaster />
      </KeycloakGate>
    </SmallScreenGate>
  );
}
